var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../store';
import { takeWhile } from 'rxjs/operators';
import * as PromoVouchersActions from '../../../../store/actions/promo-vouchers.actions';
import { INDRADiscountService } from '@ibe.services/discount.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRAPaymentService } from '@ibe.services/payment.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { DISCOUNT_AMOUNT_TYPE_FIXED, DISCOUNT_AMOUNT_TYPE_PERCENTAGE, DISCOUNT_APPLY_TO_TOTAL, DISCOUNT_TYPE_PROMOCODE, DISCOUNT_TYPE_VOUCHER, DISCOUNT_STATUS_ACTIVE, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET, SPECIAL_CASE_MARKET_LANGUAGE_MAP } from '@ibe.config';
import { INDRAMilesService } from '@ibe.services/miles.indra.service';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import * as MilesBarActions from '@ibe/store/actions/miles-bar.actions';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
var INDRAVoucherOrPromocodeComponent = /** @class */ (function () {
    function INDRAVoucherOrPromocodeComponent(sidebarService, route, store, router, ibeAdminService, ibeAdminConfigService, discountService, currencyService, dateService, flightPriceService, milesService, indraPaymentService, paymentInfoService) {
        var _this = this;
        this.sidebarService = sidebarService;
        this.route = route;
        this.store = store;
        this.router = router;
        this.ibeAdminService = ibeAdminService;
        this.ibeAdminConfigService = ibeAdminConfigService;
        this.discountService = discountService;
        this.currencyService = currencyService;
        this.dateService = dateService;
        this.flightPriceService = flightPriceService;
        this.milesService = milesService;
        this.indraPaymentService = indraPaymentService;
        this.paymentInfoService = paymentInfoService;
        this.isAlive = true;
        this.INDRA_hasErrors = false;
        this.INDRA_hasPinErrors = false;
        this.environment = environment;
        this.formAdd = new FormGroup({
            promocode: new FormControl(null, Validators.required),
            promocodeemail: new FormControl(null, Validators.required),
            promocodepin: new FormControl(null, Validators.required)
        });
        this.validatingVoucherPromocode = false;
        this.showFormAdd = true;
        this.bookAwardFlights$ = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
        this.bookedTrip$ = this.store.select(fromStore.getSelectedBookedTrip);
        this.promocodesAndVoucher$ = this.store.select(fromStore.getSelectedPromoVouchers);
        this.promocodesAndVoucher = [];
        this.completePromocodeAndVoucherList = [];
        this.milesInFlightDiscount$ = this.store.select(fromStore.getMilesInFlightDiscount);
        this.triggerHppRedFlag$ = this.indraPaymentService.triggerHppRedFlag$;
        this.triggerHppRedFlag = false;
        this.discounts = [];
        this.discountList = [];
        this.showError = false;
        this.loading = false;
        this.allSubscriptions = [];
        this.errorsVouchers = [];
        this.FIXED_DISCOUNT = DISCOUNT_AMOUNT_TYPE_FIXED;
        this.PERCENTAGE_DISCOUNT = DISCOUNT_AMOUNT_TYPE_PERCENTAGE;
        this.flightPrice = 0;
        this.flightTax = 0;
        this.hasMilesDiscount = false;
        this.isBookingNotCreated = true;
        this.inputCode = '';
        this.inputEmail = '';
        this.isVoucher = false;
        this.showVoucherPin = false;
        // query param value from the URL to identify whether the booking has been created or not
        var bookingCreatedParamValue = this.route.snapshot.paramMap.get('isBookingCreated');
        if (bookingCreatedParamValue === 'false') {
            this.isBookingNotCreated = true;
        }
        else {
            this.isBookingNotCreated = false;
        }
        this.bookAwardFlights$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.bookAwardFlights = value;
        });
        this.bookedTrip$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.booked_trip = value;
            if (_this.booked_trip && _this.booked_trip.flights && _this.booked_trip.flights.length > 0) {
                _this.flightPrice = _this.flightPriceService.computeSelectedFlightsTotalPrice(_this.booked_trip.flights, _this.booked_trip.booking_type, _this.bookAwardFlights);
                _this.flightTax = _this.flightPriceService.computeSelectedFlightsTotalTax(_this.booked_trip.flights, _this.booked_trip.booking_type, _this.bookAwardFlights);
            }
            else {
                _this.flightPrice = 0;
                _this.flightTax = 0;
            }
        });
        this.promocodesAndVoucher$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.promocodesAndVoucher = !value ? [] : value;
            _this.promocodesAndVoucher = value;
            if (_this.promocodesAndVoucher) {
                _this.completePromocodeAndVoucherList = value;
                _this.discounts = _this.promocodesAndVoucher.filter(function (discount) { return discount.status === DISCOUNT_STATUS_ACTIVE; });
                if (_this.discounts.filter(function (discount) { return discount.type === DISCOUNT_TYPE_PROMOCODE; }).length === 1 ||
                    _this.discounts.filter(function (discount) { return discount.type === DISCOUNT_TYPE_VOUCHER; }).length === 3 ||
                    _this.discounts.length === 3) {
                    _this.showFormAdd = false;
                }
                else {
                    _this.showFormAdd = true;
                }
            }
            else {
                _this.showFormAdd = true;
            }
        });
        this.milesInFlightDiscount$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (milesInFlightDiscount) {
            if (milesInFlightDiscount && milesInFlightDiscount.miles > 0) {
                _this.hasMilesDiscount = true;
                _this.showFormAdd = false;
            }
            else {
                _this.hasMilesDiscount = false;
                _this.showFormAdd = true;
            }
        });
        this.triggerHppRedFlag$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.triggerHppRedFlag = value;
        });
    }
    INDRAVoucherOrPromocodeComponent.prototype.ngOnInit = function () {
    };
    INDRAVoucherOrPromocodeComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_addVoucher = function () {
        if (this.triggerHppRedFlag) {
            return;
        }
        var isPromoEmail = this.formAdd.get('promocode').value && this.formAdd.get('promocodeemail').value;
        var hasPin = this.formAdd.get('promocodepin').value;
        if (this.formAdd.valid || isPromoEmail) {
            if (hasPin) {
                this.validatingVoucherPromocode = true;
                this.INDRA_hasPinErrors = false;
                this.INDRA_validateVoucherPin();
            }
            else {
                if (this.showVoucherPin) {
                    this.INDRA_hasPinErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.couldNotValidate');
                }
                else {
                    var value = this.formAdd.get('promocode').value.trim();
                    if (this.formAdd.get('promocodeemail')) {
                        this.inputEmail = this.formAdd.get('promocodeemail').value.trim();
                    }
                    this.INDRA_hasErrors = false;
                    this.validatingVoucherPromocode = true;
                    this.INDRA_validateDiscounts(value);
                }
            }
        }
        else {
            if (this.inputCode && !this.isVoucher) {
                var value = this.formAdd.get('promocode').value.trim();
                this.INDRA_hasErrors = false;
                this.validatingVoucherPromocode = true;
                this.INDRA_validateDiscounts(value);
            }
            else {
                this.validatingVoucherPromocode = false;
                this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.voucherPromocodeRequired');
            }
        }
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_validateDiscounts = function (value) {
        if (this.discounts.length > 1) {
            var voucherFilter = this.discounts.filter(function (cur) { return cur.type === DISCOUNT_TYPE_VOUCHER; });
            var promoCodeFilter = this.discounts.filter(function (cur) { return cur.type === DISCOUNT_TYPE_PROMOCODE; });
            if ((voucherFilter.length === 3 && promoCodeFilter.length === 0) || (voucherFilter.length === 2 && promoCodeFilter.length === 1)) {
                this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.maxDiscount');
                this.validatingVoucherPromocode = false;
                this.INDRA_formReset();
                return;
            }
        }
        var discountsIdx = this.discounts.findIndex(function (cur) { return cur.code == value; });
        if (discountsIdx === -1) {
            this.INDRA_validatePromoCode(value);
        }
        else {
            this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.promoVoucherExists');
            this.validatingVoucherPromocode = false;
        }
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_addAnotherVoucher = function () {
        if (this.triggerHppRedFlag) {
            return;
        }
        this.showFormAdd = true;
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_removePromocode = function (discount) {
        var _this = this;
        if (this.triggerHppRedFlag) {
            return;
        }
        this.loading = true;
        this.removeVoucherSubscription = this.discountService.INDRA_removeVoucherInSession(discount.code).subscribe(function (voucher) {
            if (voucher.status === '200') {
                var currDiscountList = _this.completePromocodeAndVoucherList.filter(function (x) { return x.code !== discount.code; });
                _this.store.dispatch(new PromoVouchersActions.PutPromoVouchersAction(currDiscountList));
                _this.loading = false;
                _this.INDRA_triggerBookingTotalsUpdate();
            }
            else {
                _this.removePromocodeSubscription = _this.discountService.INDRA_removePromoCodeInSession(discount.code).subscribe(function (promo) {
                    if (promo.status === '200' || promo.status === '406' || promo.errors === null) {
                        var currDiscountList = _this.completePromocodeAndVoucherList.filter(function (x) { return x.code !== discount.code; });
                        _this.store.dispatch(new PromoVouchersActions.PutPromoVouchersAction(currDiscountList));
                        _this.loading = false;
                        _this.INDRA_triggerBookingTotalsUpdate();
                    }
                    else {
                        _this.showError = true;
                        _this.loading = false;
                    }
                }, function (err) {
                    if (err) {
                        _this.INDRA_triggerBookingTotalsUpdate();
                        _this.showError = true;
                        _this.loading = false;
                    }
                });
            }
        }, function (error) {
            if (error) {
                _this.INDRA_triggerBookingTotalsUpdate();
                _this.showError = true;
            }
        });
        this.showFormAdd = true;
        this.allSubscriptions.push(this.removeVoucherSubscription);
        this.allSubscriptions.push(this.removePromocodeSubscription);
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_close = function (event) {
        if (event) {
            this.showError = false;
        }
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_validateVoucher = function (value) {
        var _this = this;
        this.validatingVoucherPromocode = true;
        var voucherRequest = {
            'voucher': value,
            'email': this.inputEmail
        };
        this.discountService.validateVoucherPromoCode(voucherRequest, DISCOUNT_TYPE_VOUCHER).subscribe(function (voucher) {
            if (voucher.status === '200') {
                if (voucher.data === null) {
                    // MFA is active for vouchers
                    _this.showVoucherPin = true;
                    _this.INDRA_hasPinErrors = false;
                    _this.validatingVoucherPromocode = false;
                }
                else {
                    _this.INDRA_applyVoucherDiscount(value, voucher);
                }
            }
            else {
                if (voucher.errors && voucher.errors.desc) {
                    _this.INDRA_hasErrors = _this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.invalidVoucherNumber');
                }
                else {
                    _this.INDRA_hasErrors = _this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.couldNotValidate');
                }
                _this.validatingVoucherPromocode = false;
            }
        }, function (err) {
            _this.INDRA_hasErrors = _this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.couldNotValidate');
            _this.validatingVoucherPromocode = false;
        });
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_validatePromoCode = function (value) {
        var _this = this;
        this.discountService.validateVoucherPromoCode(value, DISCOUNT_TYPE_PROMOCODE, this.bookAwardFlights).subscribe(function (promo) {
            if (promo.status === '200') {
                var currency = _this.currencyService.INDRA_getCurrencySymbol();
                if (!promo.data.basicInfo || !promo.data.basicInfo.currency) {
                    _this.INDRA_hasErrors = _this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.invalidPromocode');
                    _this.validatingVoucherPromocode = false;
                }
                else if (promo.data.basicInfo.currency !== 'FFP' && promo.data.basicInfo.currency !== currency.name) {
                    _this.INDRA_hasErrors = _this.INDRA_getTextTranslation('bookingSearch.errorMessage.promocodeInvalidCurrency');
                    _this.validatingVoucherPromocode = false;
                    _this.discountService.INDRA_removePromoCodeInSession(value); // added because backend api is not validating promocode currency
                }
                else if (promo.data.basicInfo.currency !== 'FFP' && _this.bookAwardFlights) {
                    _this.INDRA_hasErrors = _this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.invalidPromocode');
                    _this.validatingVoucherPromocode = false;
                }
                else if (promo.data.basicInfo.currency === 'FFP' && !_this.bookAwardFlights) {
                    _this.INDRA_hasErrors = _this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.milesPromocode');
                    _this.validatingVoucherPromocode = false;
                }
                else {
                    var promoCodesIndex = _this.discounts.findIndex(function (cur) { return cur.type.toLowerCase().trim() == DISCOUNT_TYPE_PROMOCODE; });
                    if (promoCodesIndex === -1) {
                        var newDiscountList = _this.completePromocodeAndVoucherList.filter(function (x) { return x.code !== value; });
                        // this will only have a value after the flight has been selected, otherwise this property is not existing
                        var actualDiscountAmount = promo.data && promo.data.fareData && promo.data.fareData.totalPromocodeDiscount ?
                            promo.data.fareData.totalPromocodeDiscount : null;
                        newDiscountList.push({
                            code: value,
                            type: DISCOUNT_TYPE_PROMOCODE,
                            amount: promo.data.basicInfo.discounts[0].amountType === 2 && actualDiscountAmount ? actualDiscountAmount : promo.data.basicInfo.discounts[0].discount,
                            currencyCode: promo.data.basicInfo.currency !== 'FFP' ? promo.data.basicInfo.currency : 'M',
                            status: DISCOUNT_STATUS_ACTIVE,
                            amountType: promo.data.basicInfo.discounts[0].amountType === 2 ? DISCOUNT_AMOUNT_TYPE_FIXED : DISCOUNT_AMOUNT_TYPE_PERCENTAGE,
                            applyTo: promo.data.extraInfo && promo.data.extraInfo.discounts ? promo.data.extraInfo.discounts[0].applyTo : null,
                            actualValue: actualDiscountAmount ? actualDiscountAmount : (promo.data.basicInfo.discounts[0].amountType === 2 ? promo.data.basicInfo.discounts[0].discount : 0)
                        });
                        _this.store.dispatch(new PromoVouchersActions.PutPromoVouchersAction(newDiscountList));
                        _this.showFormAdd = false;
                        _this.INDRA_formReset();
                        _this.INDRA_triggerBookingTotalsUpdate();
                    }
                    else {
                        _this.INDRA_hasErrors = _this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.max1Promocode');
                    }
                    _this.validatingVoucherPromocode = false;
                }
            }
            else {
                var fieldErrors = promo.errors && promo.errors.fieldErrors && promo.errors.fieldErrors.length > 0 ? promo.errors.fieldErrors : [];
                if (promo.status === '400' && fieldErrors.filter(function (error) { return error.code === '1083'; }).length > 0) {
                    _this.INDRA_hasErrors = _this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.milesPromocode');
                    _this.validatingVoucherPromocode = false;
                }
                else {
                    _this.INDRA_validateVoucher(value);
                    // this.validatingVoucherPromocode = false;
                }
            }
        }, function (error) {
            _this.INDRA_validateVoucher(value);
        });
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_validateVoucherPin = function () {
        var _this = this;
        var value = this.formAdd.get('promocode').value.trim();
        var email = this.formAdd.get('promocodeemail').value.trim();
        var mfaCode = this.formAdd.get('promocodepin').value.trim();
        this.voucherCodeSubscription =
            this.discountService.INDRA_validateVoucherPin(value, email, mfaCode).subscribe(function (voucher) {
                if (voucher.status === '200') {
                    _this.INDRA_applyVoucherDiscount(value, voucher);
                }
                else {
                    if (voucher.status === '403' && voucher.errors.desc) {
                        _this.INDRA_hasPinErrors = voucher.errors.desc;
                    }
                    else {
                        _this.INDRA_hasPinErrors = _this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.couldNotValidate');
                    }
                    _this.validatingVoucherPromocode = false;
                }
            }, function (err) {
                if (err) {
                    if (err.status) {
                        _this.INDRA_hasPinErrors = _this.INDRA_getTextTranslation('bookingSearch.errorMessage.couldNotValidate');
                        _this.validatingVoucherPromocode = false;
                    }
                }
            });
        this.allSubscriptions.push(this.voucherCodeSubscription);
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_applyVoucherDiscount = function (value, voucher) {
        var voucherFilter = this.discounts.filter(function (cur) { return cur.type === DISCOUNT_TYPE_VOUCHER; });
        if (voucherFilter.length <= 2) {
            var newDiscountList = this.completePromocodeAndVoucherList.filter(function (x) { return x.code !== value; });
            newDiscountList.push({
                code: value,
                type: DISCOUNT_TYPE_VOUCHER,
                amount: voucher.data.voucher.balance,
                currencyCode: voucher.data.voucher.currency,
                status: DISCOUNT_STATUS_ACTIVE,
                amountType: DISCOUNT_AMOUNT_TYPE_FIXED,
                applyTo: DISCOUNT_APPLY_TO_TOTAL,
                actualValue: voucher.data.voucher.balance,
                email: this.inputEmail
            });
            this.store.dispatch(new PromoVouchersActions.PutPromoVouchersAction(newDiscountList));
            this.showFormAdd = false;
            this.INDRA_formReset();
            this.INDRA_triggerBookingTotalsUpdate();
        }
        else {
            this.INDRA_hasErrors = this.INDRA_getTextTranslation('bookingSearch.errorMessage.voucherLimit');
        }
        this.validatingVoucherPromocode = false;
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_getTextTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_redirectToUrl = function (key) {
        var languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
        var languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
        var marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
        var urlNavigate = urlIbeAdmin.replace('${lang}', "" + languageMap).replace('${market}', "" + marketCode);
        return window.open(urlNavigate);
    };
    // only for percentage-type promocodes
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_displayActualDiscountAmount = function (discount) {
        if (discount.currencyCode != 'M') {
            return discount.actualValue;
        }
        else {
            return discount.actualValue.toFixed(0);
        }
    };
    // SIDEBAR INTERACTIONS
    /** Close sidebar and clear secondary route */
    INDRAVoucherOrPromocodeComponent.prototype.closeSidebar = function () {
        this.sidebarService.closeSidebar();
        this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
    };
    /** Handles close action intention **/
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_handleClose = function () {
        this.closeSidebar();
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_removeMiles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var updateMilesPromise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.router.url.includes('/booking/flights') || this.router.url.includes('/booking/flights-multicity'))) return [3 /*break*/, 1];
                        this.store.dispatch(new FlightsFilterActions.PutFlightWithMiles(false));
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.milesService.INDRA_updateMiles(0).toPromise()];
                    case 2:
                        updateMilesPromise = _a.sent();
                        this.milesService.oldMilesValue = 0;
                        this.INDRA_triggerBookingTotalsUpdate();
                        _a.label = 3;
                    case 3:
                        this.hasMilesDiscount = false;
                        // remove discounts on store and update miles slider 
                        this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction({ miles: 0, cash: 0 }));
                        this.store.dispatch(new MilesBarActions.SetDiscount(0));
                        this.store.dispatch(new BookedTripActions.PutBookedTripDiscountsAction([]));
                        return [2 /*return*/];
                }
            });
        });
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_triggerBookingTotalsUpdate = function () {
        if (this.router.url.includes('review-your-trip') || this.router.url.includes('extras-to-your-trip') || (this.isBookingNotCreated && this.router.url.includes('payment'))) {
            this.paymentInfoService.setUpdateBookingTotals(true);
        }
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_formReset = function () {
        this.formAdd.reset();
        this.inputCode = null;
        this.isVoucher = false;
    };
    INDRAVoucherOrPromocodeComponent.prototype.INDRA_valuechange = function (event) {
        this.inputCode = event;
        if ((this.inputCode.toUpperCase()).includes('VCHDB')) {
            this.isVoucher = false;
            this.showVoucherPin = false;
            this.formAdd.controls['promocodeemail'].setValue(null);
            this.formAdd.controls['promocodepin'].setValue(null);
        }
        else {
            if (this.inputCode.length >= 19 && this.inputCode.length <= 20) {
                this.isVoucher = true;
            }
            else {
                this.isVoucher = false;
                this.showVoucherPin = false;
                this.formAdd.controls['promocodeemail'].setValue(null);
                this.formAdd.controls['promocodepin'].setValue(null);
            }
        }
    };
    return INDRAVoucherOrPromocodeComponent;
}());
export { INDRAVoucherOrPromocodeComponent };
